export default __webpack_public_path__ + "static/media/12-18.f1c9a442.png";